import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ToolBuilder } from '../../models/builders/tool.builder';
import { ToolHolder } from '../../models/tool-holder';

const toolHolderBody = (toolHolder: ToolHolder) => ({
  hash: toolHolder.hash,
  name: toolHolder.name,
  erp: toolHolder.erp,
  toolHolderSteps: toolHolder.toolHolderSteps,
  camToolHolders: toolHolder.camToolHolders,
  toolHolderRebuildOptions: toolHolder.toolHolderRebuildOptions
});

@Injectable()
export class ToolHolderApiService {

  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }toolHolders`;
  }

  getToolHolderSteps(hash: string) {
    const params = new HttpParams().append('hash', hash);

    return this.httpClient.get(`${ this.apiUrl }/toolHolderSteps`, { params }).pipe(map(ToolBuilder.buildHolderStepsFromList));
  }

  searchToolHolders(search: string) {
    const params = new HttpParams().append('search', search);

    return this.httpClient.get(`${ this.apiUrl }/search`, { params })
      .pipe(
        map(ToolBuilder.buildToolHolderFromList)
      );
  }

  createZollerToolHolder(toolHolder) {
    return this.httpClient.post(`${ this.apiUrl }/zoller`, toolHolderBody(toolHolder)).pipe(map(ToolBuilder.buildToolHolderFromJson));
  }

  createHaimerToolHolder(toolHolder) {
    return this.httpClient.post(`${ this.apiUrl }/haimer`, toolHolderBody(toolHolder)).pipe(map(ToolBuilder.buildToolHolderFromJson));
  }

  deleteToolHolder(toolHolder: ToolHolder) {
    return this.httpClient.delete(`${ this.apiUrl }/${ toolHolder.hash }`);
  }

  getToolHolders() {
    return this.httpClient.get(`${ this.apiUrl }`).pipe(map(ToolBuilder.buildToolHolderFromList));
  }

  getToolHolder(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`).pipe(map(ToolBuilder.buildToolHolderFromJson));
  }

  searchToolHoldersByReference(search: string, notFind: string[]) {
    let params = new HttpParams().append('search', search);
    if (notFind) {
      params = params.set('notFind', notFind.toString());
    }
    return this.httpClient.get(`${this.apiUrl}/search-by-code`, { params }).pipe(map(ToolBuilder.fromList));
  }

  updateZollerToolHolder(toolHolder: ToolHolder) {
    return this.httpClient.put(`${ this.apiUrl }/zoller/${ toolHolder.hash }`, toolHolderBody(toolHolder));
  }

  updateHaimerToolHolder(toolHolder: ToolHolder) {
    return this.httpClient.put(`${ this.apiUrl }/haimer/${ toolHolder.hash }`, toolHolderBody(toolHolder));
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/tool-holder-api.service.ts